import * as React from "react"
import colors from "@digits-shared/themes/colors"
import styled from "styled-components"
import { Layout } from "src/frontend/components/OS/Applications/Home/HomeLayout/Layout"
import { useFetchPortalAndLayout } from "src/frontend/components/Shared/Portals/State/useFetchPortalAndLayout"
import { useResetPortalPerLE } from "src/frontend/components/Shared/Portals/State/useResetPortalPerLE"

const ModuleWrapper = styled.div`
  .desktop & {
    background: ${colors.cloudWhite};
    border: 1px solid ${colors.white};
    border-radius: 16px;
    padding: 0 16px;
  }
  .mobile & {
    padding: 0 12px 24px;
  }

  border-radius: inherit;
  display: flex;
  flex-direction: column;
`

export const PortalContent: React.FC = () => {
  useFetchPortalAndLayout()
  useResetPortalPerLE()

  return (
    <ModuleWrapper>
      <Layout />
    </ModuleWrapper>
  )
}
